import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

let token: string | null = null;

const httpLink = new HttpLink({
  uri: `${process.env.CRYSTAL_API_URL}/graphql`,
});

// Add the operation name to the request url for better debugging
const operationLink = new ApolloLink((operation, forward) => {
  const { operationName } = operation;
  operation.setContext({
    uri: `${process.env.CRYSTAL_API_URL}/graphql/${operationName}`,
  });
  return forward(operation);
});

export const createApolloClient = () => {
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
    };
  });

  const link = authLink.concat(operationLink.concat(httpLink));

  return new ApolloClient({
    link,
    cache: new InMemoryCache({
      // Prefer rowId, fallback to id. Guard against missing __typename to prevent cache collisions.
      dataIdFromObject(obj) {
        const typename = (obj as any).__typename as string | undefined;
        const rowId = (obj as any).rowId;
        const id = (obj as any).id;

        // Prefer rowId, fallback to id
        const key = rowId ?? id;

        if (key === null || key === undefined) return undefined;

        // Use typename if available, otherwise create safe fallback key
        return typename ? `${typename}:${key}` : `Entity:${key}`;
      },
    }),
  });
};

export const updateToken = (_token: string | null) => {
  token = _token;
};
